export default __webpack_public_path__ + "static/projectsMain-040e30c8bde9fdf3308c70e28c0a6a34.png";